import { makeStyles, styled } from "@mui/styles"
import { flow } from "fp-ts/es6/function"
import T from "prop-types"
import { of, prop } from "ramda"
import { cx } from "ramda-extension/es"
import { createElement as h } from "react"

const Element = styled("div")({
  display: "flex",
  flexWrap: "wrap",
})

const useDynamicStyles = makeStyles(({}) => ({
  root: {
    alignItems: flow(prop("align"), of),
    gap: flow(prop("gap"), of),
    justifyContent: flow(prop("align"), of),
    margin: flow(prop("margin"), of),
  },
}))

export const ButtonContainer = ({ align, children, className, gap = 20, margin }) =>
  h(
    Element,
    { className: cx(className, prop("root", useDynamicStyles({ align, gap, margin }))) },
    children,
  )

ButtonContainer.propTypes = {
  align: T.string,
  children: T.oneOfType([T.element, T.arrayOf(T.element)]),
  className: T.string,
  gap: T.number,
  margin: T.arrayOf(T.oneOfType([T.number, T.string])),
}
